import objectFitImages from 'object-fit-images'
import * as commonScripts from '../common'
import Glide from '@glidejs/glide'

const cmpPhotoCollage = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)

    // Initialize object-fit polyfill for IE
    const images = _.component.querySelectorAll('.cmp-photo-collage__item__media img')
    objectFitImages(images)

    // Define partial slides for the desktop layout
    const desktopRows = _.component.querySelectorAll('.cmp-photo-collage--desktop .row')
    desktopRows.forEach(function (el) {
      if (el.querySelectorAll('.col-collage').length < 9) {
        el.classList.add('partial')
      }
    })

    // If not in edit mode, then initialize the carousel
    if (!commonScripts.util.isEditMode()) {
      const carouselDiv = _.component.querySelectorAll('.glide')
      const autoplay = _.component.getAttribute('data-autoplay')
      let loop = _.component.getAttribute('data-loop')
      loop = loop ? loop.toLowerCase() : loop
      const options = {}
      options.gap = 32
      options.type = (loop === 'true') ? 'carousel' : 'slider'
      options.autoplay = (isNaN(autoplay) || autoplay === '0') ? false : (autoplay * 1000)
      options.rewind = false

      carouselDiv.forEach(function (el) {
        const disabler = commonScripts.util.glideArrowDisabler
        const glide = new Glide(el, options).mount({ disabler })
      })
    }
  }

}

export default cmpPhotoCollage
